import AdminLayout from './AdminLayout.vue';
import AdminDashboard from './pages/AdminDashboard.vue';
import AdminCompanies from './pages/AdminCompanies.vue';
import AdminResellers from './pages/AdminResellers.vue';
import AdminDistributors from './pages/AdminDistributors.vue';
import AdminMyRecipientDetails from './pages/AdminMyRecipientDetails.vue';
import { getTypeUser } from '@/utils';
import { TYPE_USER } from '@/utils/enums';

export default [
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, layout: 'admin' },
    children: [
      {
        path: '',
        redirect: () => (
          getTypeUser() === TYPE_USER.SUPER
            ? { name: 'admin-dashboard' }
            : { name: 'admin-companies' }
        ),
      },
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: AdminDashboard,
        meta: { requiresAuth: true, layout: 'admin' },
      },
      {
        path: 'empresas',
        name: 'admin-companies',
        component: AdminCompanies,
        meta: { requiresAuth: true, layout: 'admin' },
      },
      {
        path: 'revendedores',
        name: 'admin-resellers',
        component: AdminResellers,
        meta: { requiresAuth: true, layout: 'admin' },
      },
      {
        path: 'distribuidores',
        name: 'admin-distributors',
        component: AdminDistributors,
        meta: { requiresAuth: true, layout: 'admin' },
      },
      {
        path: 'saldo-a-receber',
        name: 'admin-my-recipient-details',
        component: AdminMyRecipientDetails,
        meta: { requiresAuth: true, layout: 'admin' },
      },
    ],
  },
];
